<template>
  <div class="claim-box">
    <div class="claim-title flex align-center">
      <i class="iconfont iconicon-kailipeidan"></i>
      <span class="size14 area-tit">索赔面板</span>
    </div>
    <div class="claim-main" v-loading="loading" v-if="hasData">
      <div class="claim-header">
        <div class="color999">恭喜您～已向亚马逊索赔</div>
        <div class="size24 colorBlue gj-font-align-center gj-mt8"><span class="gj-number ">{{totalObj.realCaseQuantity | defaultShow}}</span><span class="size14 color999 gj-ml4">笔</span></div>
        <div class="flex justify-between align-center">
          <img :src="arrowicon" class="arrowIcon"/>
          <div class="color999" v-if="totalObj.convertScale > 0">相当于{{totalObj.convertScale}}个LV包包!</div>
        </div>
        <img :src="packageIcon" class="packageIcon"/>
      </div>
      <div class="claim-content weight600 flex align-center gj-mt8">
        已索赔成功金额：<span class="colorGreen">{{totalObj.currencySymbol | optionText(dashboardCurrencysOption) | defaultShow('', '', '$')}}</span><span class="gj-number gj-ml4 size16">{{totalObj.realClaimMoney | defaultShow}}</span>
      </div>
      <div class="claim-estimate gj-mt8">
        <div class="claim-bord weight600 flex align-center">
          预计可索赔金额：{{totalObj.currencySymbol | optionText(dashboardCurrencysOption) | defaultShow('', '', '$')}}<span class="gj-number gj-ml4 size16">{{totalObj.estimateClaimMoney | defaultShow}}</span>
        </div>
        <div class="flex justify-between hei70">
          <div class="flex flex-direction-column justify-center">
            <div class="color999">
              库存索赔({{totalObj.currencySymbol | optionText(dashboardCurrencysOption) | defaultShow('', '', '$')}})
              <gj-tooltip content="商品在亚马逊仓库中丢失或损坏">
                <i class="iconfont iconbangzhu"></i>
              </gj-tooltip>
            </div>
            <div class="size16 color666 gj-number gj-mt5">{{totalObj.storageEstimateClaimMoney | defaultShow}}</div>
          </div>
          <div class="flex flex-direction-column justify-center">
            <div class="color999">
              退货索赔({{totalObj.currencySymbol | optionText(dashboardCurrencysOption) | defaultShow('', '', '$')}})
              <gj-tooltip content="买家未退回商品或者退回的商品被亚马逊损坏">
                <i class="iconfont iconbangzhu"></i>
              </gj-tooltip>
            </div>
            <div class="size16 gj-number color666 gj-mt5">{{totalObj.returnedEstimateClaimMoney | defaultShow}}</div>
          </div>
          <div class="flex flex-direction-column justify-center">
            <div class="color999">
              货件索赔({{totalObj.currencySymbol | optionText(dashboardCurrencysOption) | defaultShow('', '', '$')}})
              <gj-tooltip content="货件拣货入库亚马逊仓库时丢失">
                <i class="iconfont iconbangzhu"></i>
              </gj-tooltip>
            </div>
            <div class="size16 gj-number color666 gj-mt5">{{totalObj.shipmentEstimateClaimMoney | defaultShow}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="claim-main flex justify-center align-center" style="background: #E7EBF2; border-radius: 0;" v-if="!hasData">
      <div class="weight600 size24">暂无索赔数据</div>
    </div>
  </div>
</template>

<script>
import { claimStatistics } from "@/api/dashboard"
import {isMeaningful} from "@/utils/common";
import { dashboardCurrencysOption } from "@/utils/options";
import {dashboardMixin, queryMixin} from "@/minxins";
import BigNumber from 'bignumber.js';
export default {
  name: "dashboard-claim",
  mixins: [queryMixin, dashboardMixin],
  data(){
    return {
      hasData: true,
      totalObj: {},
      packageIcon: require("@/assets/images/dashboard/package.png"),
      arrowicon: require("@/assets/images/dashboard/arrowicon.png"),
      dashboardCurrencysOption
    }
  },
  activated() {
    this.$gjQuery()
  },
  methods: {
    // 获取数据
    $gjQuery() {
      if(!this.showStoreMask){
        return
      }
      this.loading = true
      let params = {
        countryCodes: this.countryMarket.countryIds,
        marketIds: this.countryMarket.marketIds,
        currency: this.dashboardCurrency
      }
      claimStatistics(params).then(data => {
        this.totalObj = data || {}
      }).complete(() => {
        this.loading = false;
        this.hasData = isMeaningful(this.totalObj)
      });
    },
  }
}
</script>


<style scoped lang="scss">
.claim-box{
  background-color: #fff;
  height: 372px;
  padding: 0 16px;
  border-radius: 4px;
  justify-content: space-between;
  .claim-title{
    height: 54px;
  }
  .claim-main {
    height: 300px;
    background: #E3EEFF;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    .claim-header {
      font-size: 14px;
      height: 92px;
      padding: 8px 12px;
      box-sizing: border-box;
      background: #FFFFFF;
      border-radius: 4px;
      position: relative;
      .packageIcon {
        position: absolute;
        top: -14px;
        right: -14px;
      }
      .arrowIcon {
        width: 20px;
        height: 8px;
      }
    }
    .claim-content {
      background: #FFFFFF;
      border-radius: 2px;
      height: 52px;
      font-size: 14px;
      box-sizing: border-box;
      padding: 0 12px;
    }
    .claim-estimate {
      background: #FFFFFF;
      border-radius: 2px;
      height: 122px;
      font-size: 14px;
      box-sizing: border-box;
      padding: 0 8px 0 12px;
      .claim-bord {
        height: 52px;
        font-size: 14px;
        color: #666666;
        border-bottom: 1px solid #D8DADD;
      }
      .hei70 {
        height: 70px;
      }
    }
  }
}
.gj-number {
  font-family: DINAlternate-Bold;
  font-weight: 700;
}
</style>